import type { ExternalTableSchema } from '@packages/table-builder';

export const companySsoTable: ExternalTableSchema = {
  metadata: {
    title: 'SSO Configuration',
    entity: 'CompanySso',
    description: 'Manage company SSO configurations.',
  },

  dataSource: {
    endpoint: '/api/identity/api/app/company-sso-configuration',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
    },
  },

  columns: [
    { field: 'displayName', header: 'Display Name', type: 'text', width: 200, sortable: true },
    { field: 'providerName', header: 'Provider Name', type: 'text', width: 200, sortable: true },
    { field: 'clientId', header: 'Client ID', type: 'text', width: 200, sortable: true },
    { field: 'authority', header: 'Authority', type: 'text', width: 250, sortable: true },
    { field: 'redirectUri', header: 'Redirect URI', type: 'text', width: 350, sortable: true },
    {
      field: 'isEnabled',
      header: 'Status',
      type: 'badge',
      width: 120,
      align: 'center',
      badge: {
        statusMap: { true: 'success', false: 'error' },
        displayMap: { true: 'Enabled', false: 'Disabled' },
        defaultVariant: 'info',
      },
      conditionalValues: { true: 'Enabled', false: 'Disabled' },
    },
    {
      field: 'createdDate',
      header: 'Created Date',
      type: 'date',
      width: 150,
      sortable: true,
    },
  ],

  actions: {
    row: [
      { id: 'VIEW_COMPANY_SSO', label: 'View' },
      { id: 'EDIT_COMPANY_SSO', label: 'Edit' },
      { id: 'ENABLE_COMPANY_SSO', label: 'Enable' },
      { id: 'DISABLE_COMPANY_SSO', label: 'Disable' },
      { id: 'UPDATE_SIGNING_CERTIFICATE_COMPANY_SSO', label: 'Update Signing Certificate' },
    ],
    toolbar: {
      primary: {
        id: 'ADD_COMPANY_SSO',
        label: 'Add SSO Configuration',
        icon: 'add_circle',
      },
    },
  },

  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    columnPreferences: {
      persistenceKey: 'Company SSO',
      resizable: true,
      reorderable: true,
    },
  },
};
